  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;

    self.updateCart = function() {
      // Page-level loading overlay intentionally NOT shown here as of Phase 6
      // P6-B2. Cart-mutation callers add `.is-updating` to the affected row.
      // Cart-summary upsell ATC (sections/cart_content.liquid) shows its own
      // overlay before invoking this. The `always: hideLoadingOverlay` below
      // still cleans up if a caller did show one.
      var sectionUrl = location.pathname + location.search + (location.search ? '&':'?') + 'sections=cart_content';
      $s.getJson({
        url: sectionUrl,
        success: function(data){
          try {
            var section = document.querySelector('.cart-content');
            $s.updateDynamicContent(section, data['cart_content']);
            var summaryWrapper = document.querySelector('#cart .summary-column');
            if (summaryWrapper) {
              if (section.querySelector('.cart-items')) {
                summaryWrapper.style.display = '';
              } else {
                summaryWrapper.style.display = 'none';
              }
            }
            $s.globalEval(data['cart_content']);
            // Defer one tick so any synchronous post-render writes settle first.
            if ($s && typeof $s.refreshHeaderCartCount === 'function') {
              setTimeout(function() { $s.refreshHeaderCartCount(); }, 50);
            }
          } catch (e) {
            console.error(e);
          }
        },
        error: function() {
        },
        always: function() {
          $s.hideLoadingOverlay();
        }
      });
    }

    self.updateItemsQuantity = function(items, quantity){
      // P3-2: POST/optimistic core lives in $s.postCartQuantityUpdate.
      // Keep source labels + success fork local — do NOT call
      // $s.addToCartSuccess from /cart (that would try to open the drawer).
      // Grouped mutations: assets/cart_handlers.js.liquid (P6-E1).
      var isRemove = (quantity * 1) === 0;
      var source = isRemove ? 'cart-page-remove' : 'cart-page-qty';
      $s.postCartQuantityUpdate({
        items: items,
        quantity: quantity,
        onSuccess: function(response) {
          var commit = function(){
            if ($s && typeof $s.refreshHeaderCartCount === 'function') {
              $s.refreshHeaderCartCount(response);
            }
            if ($s && typeof $s.emitCartUpdated === 'function') {
              $s.emitCartUpdated(response, source);
            }
            self.updateCart();
          };
          if (isRemove && ($s.cartV2 || $s.cartV3)) {
            setTimeout(commit, $s.SECTION_REFRESH_DEFER_MS);
          } else {
            commit();
          }
        }
      });
    }
  
  };

  /*
    Mobile sticky bottom bar — see sections/cart_content.liquid for markup
    and CSS. Owns three behaviors:
      1. Smooth-scroll to #cart-summary-anchor when the chevron row is
         tapped (respects prefers-reduced-motion).
      2. Auto-hide via IntersectionObserver once the full Order Summary
         column is visible in the reading area, so the customer doesn't
         see redundant chrome when they're already looking at the totals.
      3. Empty-cart hide — handled by Liquid + the data-dynamic-content
         marker on the outer element: when cart becomes empty after an
         AJAX update, $s.updateDynamicContent replaces the entire bar
         (including its [hidden] attribute), and our connectedCallback
         re-runs against the fresh element.

    Guarded with `customElements.get` so re-evaluating this script after a
    section re-render (via $s.globalEval) doesn't throw on duplicate
    registration.
  */
  if (!customElements.get('cart-sticky-bar')) {
    customElements.define('cart-sticky-bar', class extends HTMLElement {
      connectedCallback() {
        // Bind the chevron click first and outside the try block — if
        // anything below explodes, smooth-scroll still works.
        var self = this;
        this._chevron = this.querySelector('[data-cart-sticky-chevron]');
        this._onChevronClick = function (e) {
          e.preventDefault();
          var anchorId = self.dataset.target || 'cart-summary-anchor';
          var anchor = document.getElementById(anchorId);
          if (!anchor) return;
          var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var behavior = prefersReduce ? 'auto' : 'smooth';
          try {
            anchor.scrollIntoView({ behavior: behavior, block: 'start' });
          } catch (err) {
            // Older browsers may not support the options object.
            anchor.scrollIntoView();
          }
        };
        if (this._chevron) {
          this._chevron.addEventListener('click', this._onChevronClick);
        }

        try {
          this._mq = window.matchMedia('(max-width: 600px)');
          this._onMqChange = function () {
            self._teardownObserver();
            if (self._mq.matches) {
              self._setupObserver();
            } else {
              // Switching from mobile to desktop: drop any leaked auto-hide
              // state so a future return to mobile starts from a clean baseline.
              self.classList.remove('is-hidden');
              self.removeAttribute('inert');
            }
          };
          if (this._mq.addEventListener) {
            this._mq.addEventListener('change', this._onMqChange);
          } else if (this._mq.addListener) {
            // Safari < 14 fallback for MediaQueryList.
            this._mq.addListener(this._onMqChange);
          }
          this._setupObserver();
        } catch (err) {
          // Auto-hide is a nice-to-have; never let it break the bar itself.
          if (window.console && console.warn) {
            console.warn('[cart-sticky-bar] auto-hide setup failed:', err);
          }
        }
      }

      disconnectedCallback() {
        if (this._chevron && this._onChevronClick) {
          this._chevron.removeEventListener('click', this._onChevronClick);
        }
        if (this._mq && this._onMqChange) {
          if (this._mq.removeEventListener) {
            this._mq.removeEventListener('change', this._onMqChange);
          } else if (this._mq.removeListener) {
            this._mq.removeListener(this._onMqChange);
          }
        }
        this._teardownObserver();
      }

      _setupObserver() {
        // Only run on mobile — the bar is display:none on desktop, so the
        // observer would only burn cycles re-toggling an invisible element.
        if (!this._mq || !this._mq.matches) return;
        if (!('IntersectionObserver' in window)) return;

        var anchorId = this.dataset.target || 'cart-summary-anchor';
        var anchor = document.getElementById(anchorId);
        if (!anchor) return;

        var self = this;
        // Negative bottom rootMargin shrinks the IO root by the bar's
        // approximate height (matches the padding-bottom reservation in
        // sections/cart_content.liquid). Effect: the bar hides only when
        // the summary column actually intersects the user's reading area
        // above the bar — not when it merely overlaps the bar's footprint.
        this._observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              self.classList.add('is-hidden');
              self.setAttribute('inert', '');
            } else {
              self.classList.remove('is-hidden');
              self.removeAttribute('inert');
            }
          });
        }, {
          rootMargin: '0px 0px -180px 0px',
          threshold: 0.01
        });
        this._observer.observe(anchor);
      }

      _teardownObserver() {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
      }
    });
  }

  //runs every time #cart div is replaced
  // NOTE (Apr 30, 2026): the legacy block that summed quantity inputs and
  // wrote the total to `header .cart-count` was removed. It depended on the
  // IIFE re-evaluating after every section refresh, which `globalEval`
  // doesn't do reliably (the appendChild+removeChild dance for external
  // `<script src>` tags can abort execution in some browsers, leaving the
  // badge stale). The defensive `setTimeout` + `/cart.js` fetch inside
  // `updateCart` (above) handles the badge refresh authoritatively.
  var cart = document.getElementById('cart');

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      if(this.closest('.item').classList.contains('group-main')){
        var data = [];
        data.push(this.closest('.item'));
        var groupId = this.closest('.item').dataset.groupId;
        this.closest('.cart-items').querySelectorAll('.item.group-addon').forEach((it) => {
          if(it.dataset.groupId == groupId){
            data.push(it);
          }
        });
        CartPage.updateItemsQuantity(data, 0);
      }else{
        CartPage.updateItemsQuantity([this.closest('.item')], 0);
      }
    });
  });

  cart.querySelectorAll('input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      if(this.closest('.item').classList.contains('group-main')){
        var data = [];
        data.push(this.closest('.item'));
        var groupId = this.closest('.item').dataset.groupId;
        this.closest('.cart-items').querySelectorAll('.item.group-addon').forEach((it) => {
          if(it.dataset.groupId == groupId){
            data.push(it);
          }
        });
        CartPage.updateItemsQuantity(data, this.value);
      }else{
        CartPage.updateItemsQuantity([this.closest('.item')], this.value);
      }
    });
  });// Show/hide of #instructions-note is driven by CSS (sections/cart_content.liquid:
  // `.cart-addnote:has(#chk-instructions:checked) #instructions-note`).
  // We only need JS for the side-effect: when the user toggles OFF, clear any
  // existing text and dispatch `change` so cart-property-field saves an empty
  // note. Plus a keyboard handler so Enter on the focused label toggles it.
  var checkInstructions = document.getElementById('chk-instructions');
  if (checkInstructions) {
    checkInstructions.addEventListener('change', function(){
      if (checkInstructions.checked) return;
      var note = document.getElementById('instructions-note');
      if (!note) return;
      var textarea = note.querySelector('textarea');
      if (textarea && textarea.value !== '') {
        textarea.value = '';
        $s.dispatchEvent(textarea, 'change');
      }
    });
    if (checkInstructions.labels && checkInstructions.labels[0]) {
      checkInstructions.labels[0].addEventListener('keypress', function(event){
        if (event.keyCode === 13) { checkInstructions.click(); }
      });
    }
  }})();